/**
 * @fileoverview Mock implementation of InhaberService for testing and development.
 *
 * This mock service implements the InhaberService interface from the JF library
 * with stub implementations that return empty data. Used during development
 * when the actual Inhaber service is not needed or available.
 *
 * Purpose:
 * - Satisfies JF library dependency requirements
 * - Enables development without backend dependencies
 * - Provides test fixtures for unit tests
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InhaberService } from '@adnova/jf-ng-components/lib/jf-interfaces/inhaber-service.interface';
import { BetriebPageDTO } from '@adnova/jf-ng-components/lib/jf-interfaces/betrieb-page-dto.interface';
import { InhaberDTO } from '@adnova/jf-ng-components/lib/jf-interfaces/inhaber-dto.interface';

/**
 * Mock implementation of InhaberService.
 *
 * Provides stub implementations that return empty data for:
 * - getInhabers: Returns empty array of InhaberDTO
 * - getBetriebe: Returns empty BetriebPageDTO
 *
 * This service is provided in root and used when the actual Inhaber
 * functionality is not required for the chatbot application.
 *
 * @class MockInhaberService
 * @implements {InhaberService}
 */
@Injectable({
  providedIn: 'root',
})
export class MockInhaberService implements InhaberService {
  /**
   * Mock implementation of getInhabers.
   *
   * @returns {Observable<InhaberDTO[]>} Empty array of InhaberDTO
   */
  getInhabers(

  ): Observable<InhaberDTO[]> {
    return of([]);
  }

  /**
   * Mock implementation of getBetriebe.
   *
   * @returns {Observable<BetriebPageDTO>} Empty BetriebPageDTO object
   */
  getBetriebe(

  ): Observable<BetriebPageDTO> {
    return of({} as BetriebPageDTO);
  }
}
